export enum RoleRegisterMessages {
  titleCreate = "roleRegister.title.create",
  titleEdit = "roleRegister.title.edit",
  stepTabFormRole = "roleRegister.stepTab.formRole",
  stepTabAddUsers = "roleRegister.stepTab.addUsers",
  noUsersRegistered = "roleRegister.noUsersRegistered",
  userIsAMemberOfAnotherRole = "roleRegister.userIsAMemberOfAnotherRole"
}

export interface TranslationRoleRegisterMessages {
  [RoleRegisterMessages.titleCreate] : string;
  [RoleRegisterMessages.titleEdit] : string;
  [RoleRegisterMessages.stepTabFormRole] : string;
  [RoleRegisterMessages.stepTabAddUsers] : string;
  [RoleRegisterMessages.noUsersRegistered] : string;
  [RoleRegisterMessages.userIsAMemberOfAnotherRole] : string;
}
